var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"description":_vm.description,"invalid-feedback":_vm.validationError}},[_c('b-form-select',{attrs:{"options":_vm.options,"state":_vm.state},on:{"input":function($event){return _vm.updateContent()}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }